import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { LayoutModule } from "@app/shared";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { LeadLifecycleBreadCrumbIconActionsHeaderComponent } from "./lead-lifecycle-breadcrumb-icon-actions-header";
import { LeadLifecycleHeaderContainerComponent } from "./lead-lifecycle-header-container";
@NgModule({
    declarations: [LeadLifecycleHeaderContainerComponent, LeadLifecycleBreadCrumbIconActionsHeaderComponent],
    imports: [
        CommonModule,
        LayoutModule,
        ScrollPanelModule
    ],
    exports: [LeadLifecycleHeaderContainerComponent, LeadLifecycleBreadCrumbIconActionsHeaderComponent]
})
export class LeadLifecycleReusableComponentsModule { }